import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import EmailIcon from '@/components/Icons/EmailIcons';

// import AuthLayout from '@/components/Layout/AuthLayout';
import Button from '@/components/ui/Button';
import PrimaryInput from '@/components/ui/PrimaryInput';
import { IDeleteResponse } from '@/interfaces/common.model';
import { showToastNotification } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';
interface IForgetPasswordForm {
  email: string;
}
interface IForgetPasswordProps {
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  token: string | null;
}
const ForgetPassword = ({ setActiveTab, token }: IForgetPasswordProps) => {
  const navigate = useNavigate();
  const randomDeviceId = uuidv4();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [selectedOption, setSelectedOption] = useState<string>('phone');
  const {
    register,
    handleSubmit,
    // reset,
    formState: { errors },
  } = useForm<IForgetPasswordForm>();

  // const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSelectedOption(event.target.value);
  //   reset({ email: ''});
  // };

  const onSubmit = async (data: IForgetPasswordForm) => {
    setIsLoading(true);
    try {
      let deviceId = '';
      if (localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId')) {
        deviceId =
          localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId') ??
          '';
      } else {
        deviceId = '2025_' + randomDeviceId;
      }
      localStorage.setItem(
        import.meta.env.VITE_BUSINESS + 'deviceId',
        deviceId,
      );
      const fcmToken = token;
      const submitData = {
        email: data?.email,
        deviceId: deviceId,
        deviceToken: fcmToken ? fcmToken : null,
      };

      const API = `${API_URL}${API_ENDPOINT?.forgetPassword}`;
      const response = await callApi<IDeleteResponse>(API, {
        method: 'POST',
        data: submitData,
      });
      if (response) {
        setIsLoading(false);
        if (response?.status === true) {
          showToastNotification('success', response?.message);
          navigate(RoutesLink?.verifyOtp, { state: { data: submitData } });
        } else {
          showToastNotification('danger', response?.message);
        }
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <h1 className="title mb-4">Forget Password</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group mb-4 password-group">
          <PrimaryInput
            label="Email"
            type="text"
            placeholder="Enter email"
            {...register('email', {
              required: 'Please fill in your email',
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
                message: 'Invalid email address',
              },
              validate: (value) =>
                value === value.toLowerCase() || 'Email must be in lowercase',
            })}
            errors={errors?.email?.message}
            startIcon={<EmailIcon />}
          />
        </div>

        <Button
          disabled={isLoading}
          type="submit"
          className={'btn btn-primary py-2 px-4 w-100 '}
        >
          {isLoading ? <Spinner /> : 'Get OTP'}
        </Button>
        <div
          className="btn btn-link p-2 text-decoration-none welcome-login text-center mt-3 w-100 "
          onClick={() => {
            setActiveTab(1);
          }}
        >
          {'<  Back to sign in'}
        </div>
      </form>
    </>
  );
};

export default ForgetPassword;
